module.exports = __webpack_public_path__ + "img/dragons-ice.98c5f455.jpg";